import Typography from "@mui/material/Typography";
import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";
import Big from "big.js";
import { optionalEss } from "../../../Utils/UtilityMethods";
import { FUEL_LINE_ITEM_TYPES } from "../../../sharedCode/metadata";
import { TicketExtended } from "../../../Utils/TypeExtensions";

export default function FuelMenuContent(ticket: TicketExtended, title: string, validationResults: ValidationResult[]): MenuCardContent {
    const applicableLineItems = ticket?.LineItems?.filter((r) => FUEL_LINE_ITEM_TYPES.findIndex((id) => r && id === r.line_item_type_id && (r.amount ?? 0) > 0) >= 0);

    const fuelAmount = applicableLineItems?.reduce((total, lineItem) => {
        return total.add(lineItem?.amount ?? 0);
    }, new Big(0));

    // TODO look up the quantity name or stick it in context
    const details = (
        <Typography textAlign={"center"}>
            {`${(fuelAmount?.toFixed(1) ?? 0).toLocaleString()} LITRE`}
            {optionalEss(fuelAmount?.toNumber() ?? 0)}
        </Typography>
    );
    const validationMessages = TicketErrorHelper.getCardErrors(validationResults, title);

    return { details, validationMessages };
}
